import { render, staticRenderFns } from "./Alpha.vue?vue&type=template&id=5c3a5a9e&"
import script from "./Alpha.vue?vue&type=script&lang=ts&"
export * from "./Alpha.vue?vue&type=script&lang=ts&"
import style0 from "./Alpha.vue?vue&type=style&index=0&id=5c3a5a9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports